import { Grid, LinearProgress, withTheme } from '@material-ui/core';
import moment from 'moment';
import React, { useCallback, useState } from 'react';
import CalendarBody from './components/CalendarBody';
import CalendarNavigation from './components/CalendarNavigation';
import { mapBookingsToDays, uniqueTickets } from '../../calendarHelpers';

export const CALENDAR_EVENT_GAP = 20;

export const Calendar = props => {
    const {
        onEventClick,
        bookings,
        bookingsLoading,
        initialDate = moment()
            .tz('Pacific/Honolulu')
            .startOf('week')
            .startOf('day')
            .format('YYYY-MM-DD HH:mm:ss'),
        customButtons = false,
        cellHeight = 60 + CALENDAR_EVENT_GAP,
        weekDays = 7,
        paddingHoursBefore = 1,
        paddingHoursAfter = 1,
        firstDay = 0,
        unique = false,
        showCancelledDenied = true
    } = props;
    const [startDate, setStartDate] = useState(() => moment(initialDate));
    const [endDate, setEndDate] = useState(() =>
        moment(initialDate)
            .endOf('day')
            .add(weekDays - 1, 'days')
    );
    const setCalendarDate = useCallback(
        (prevWeek = false) => {
            if (prevWeek) {
                setStartDate(prevStartDate => prevStartDate.clone().subtract(weekDays, 'days'));
                setEndDate(prevEndDate => prevEndDate.clone().subtract(weekDays, 'days'));
                return;
            }
            setStartDate(prevStartDate => prevStartDate.clone().add(weekDays, 'days'));
            setEndDate(prevEndDate => prevEndDate.clone().add(weekDays, 'days'));
        },
        [setStartDate, setEndDate, weekDays]
    );

    // map incomming structure to the internal representation
    let eventsPerDay = [];
    if (bookings && !bookingsLoading) {
        const filteredBookings = bookings.filter(event =>
            showCancelledDenied
                ? event
                : event.status === 'confirmed' ||
                  event.status === 'unconfirmed' ||
                  event.status === 'in_cart'
        );
        eventsPerDay = mapBookingsToDays(
            unique ? uniqueTickets(filteredBookings) : filteredBookings,
            startDate,
            weekDays
        );
    }

    // grab all event count in the calendar
    const allEventCount = eventsPerDay.map(e => e.length).reduce((a, b) => a + b, 0);

    return (
        <Grid container item xs={12} className="mt-2 mb-2">
            <CalendarNavigation
                startDate={startDate}
                endDate={endDate}
                setCalendarDate={setCalendarDate}
                customButtons={customButtons}
            />
            {bookingsLoading && (
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <LinearProgress />
                    </Grid>
                </Grid>
            )}
            {!bookingsLoading && allEventCount === 0 && (
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        No events
                    </Grid>
                </Grid>
            )}
            {!bookingsLoading && allEventCount > 0 && (
                <CalendarBody
                    bookings={eventsPerDay}
                    startDate={startDate}
                    weekDays={weekDays}
                    paddingHoursBefore={paddingHoursBefore}
                    paddingHoursAfter={paddingHoursAfter}
                    cellHeight={cellHeight}
                    onEventClick={onEventClick}
                    firstDay={firstDay}
                />
            )}
        </Grid>
    );
};

export default withTheme(Calendar);
